"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ArrowDropDownRounded = _interopRequireDefault(require("@mui/icons-material/ArrowDropDownRounded"));
var _ArrowDropUpRounded = _interopRequireDefault(require("@mui/icons-material/ArrowDropUpRounded"));
var _ChevronLeftRounded = _interopRequireDefault(require("@mui/icons-material/ChevronLeftRounded"));
var _ChevronRightRounded = _interopRequireDefault(require("@mui/icons-material/ChevronRightRounded"));
var _Button = _interopRequireDefault(require("@mui/material/Button/Button.js"));
var _Box = _interopRequireDefault(require("@mui/material/Box"));
var _Collapse = _interopRequireDefault(require("@mui/material/Collapse"));
var _styles = require("@mui/styles");
var _classnames = _interopRequireDefault(require("classnames"));
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _styles.makeStyles)(({
  palette,
  spacing
}) => ({
  drawer: {
    display: 'flex',
    overflow: 'hidden',
    padding: spacing(1),
    flexDirection: 'column',
    alignItems: 'flex-start',
    transition: `all 500ms ease`
  },
  drawerClosed: {
    flex: '0 0 auto !important',
    width: ({
      collapsedWidth
    }) => collapsedWidth ? `${collapsedWidth}px !important` : '60px !important'
  },
  rightDrawer: {
    marginLeft: 'auto'
  },
  header: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    color: palette.text.primary
  },
  reverse: {
    flexFlow: 'row-reverse'
  }
}));
var _default = exports.default = /*#__PURE__*/(0, _react.forwardRef)(function Collapsable({
  className,
  children,
  defaultOpen,
  open: controlledOpen,
  onToggle,
  direction = 'down',
  header,
  headerClass,
  collapsedWidth,
  collapseProps = {},
  ExpandIcon = _ArrowDropDownRounded.default,
  CollapseIcon = _ArrowDropUpRounded.default,
  buttonProps,
  ...rest
}, ref) {
  const [localOpen, setLocalOpen] = (0, _react.useState)(defaultOpen ?? false);
  const isControlled = controlledOpen != null;
  const open = isControlled ? controlledOpen : localOpen;
  const fixedState = isControlled && !onToggle;
  const classes = useStyles({
    collapsedWidth
  });
  function handleToggle(e) {
    if (!isControlled) setLocalOpen(s => !s);
    onToggle?.(e);
  }
  if (direction === 'down') {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
      ref: ref,
      className: className,
      ...rest,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Button.default, {
        onClick: handleToggle,
        className: (0, _classnames.default)(classes.header, headerClass),
        size: "small",
        ...buttonProps,
        children: [header, " ", fixedState ? null : open ? /*#__PURE__*/(0, _jsxRuntime.jsx)(CollapseIcon, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(ExpandIcon, {})]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Collapse.default, {
        in: open,
        ...collapseProps,
        children: children
      })]
    });
  } else {
    const isRight = direction === 'right';
    const openIcon = isRight ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChevronLeftRounded.default, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChevronRightRounded.default, {});
    const closeIcon = isRight ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChevronRightRounded.default, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChevronLeftRounded.default, {});
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
      ref: ref,
      className: (0, _classnames.default)(classes.drawer, className, {
        [classes.drawerClosed]: !open,
        [classes.rightDrawer]: isRight
      }),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
        onClick: handleToggle,
        className: (0, _classnames.default)(classes.header, headerClass, {
          [classes.reverse]: isRight
        }),
        size: "small",
        ...buttonProps,
        children: open ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [header, " ", fixedState ? null : closeIcon]
        }) : !fixedState ? openIcon : null
      }), children]
    });
  }
});